import { AttributeDataType } from "../dataModel";
import { DataFormatter } from "@hydrosoft/utils";
export class Formatter {
    _formatter;
    constructor(options = undefined) {
        if (options === undefined) {
            options = {};
        }
        this._formatter = new DataFormatter(options);
    }
    formatInteger(value, units = undefined, thousandsSeparator = undefined) {
        if (value === null || value === undefined) {
            return "-";
        }
        const num = parseFloat(value);
        if (thousandsSeparator !== undefined) {
            this._formatter._options.thousandsSeparator = thousandsSeparator;
        }
        return this._formatter.formatNumber(num, 0, units);
    }
    formatFloat(value, units = undefined, decimals = 2, thousandsSeparator = undefined, decimalSeparator = undefined) {
        if (value === null || value === undefined) {
            return "-";
        }
        const num = parseFloat(value);
        if (thousandsSeparator !== undefined) {
            this._formatter._options.thousandsSeparator = thousandsSeparator;
        }
        if (decimalSeparator !== undefined) {
            this._formatter._options.decimalSeparator = decimalSeparator;
        }
        return this._formatter.formatNumber(num, decimals, units);
    }
    formatCoordinates(coordinates, decimals = 2, thousandsSeparator = undefined, decimalSeparator = undefined) {
        return [
            this.formatFloat(coordinates[0], undefined, decimals, thousandsSeparator, decimalSeparator),
            this.formatFloat(coordinates[1], undefined, decimals, thousandsSeparator, decimalSeparator),
        ];
    }
    formatGPS(coordinates, decimals = 2, thousandsSeparator = undefined, decimalSeparator = undefined) {
        if (thousandsSeparator !== undefined) {
            this._formatter._options.thousandsSeparator = thousandsSeparator;
        }
        if (decimalSeparator !== undefined) {
            this._formatter._options.decimalSeparator = decimalSeparator;
        }
        return this._formatter.formatGPS(coordinates, decimals);
    }
    arrayToHtml(data) {
        return JSON.stringify(data)
            .replace(/(^|[^\\])"/g, "$1'")
            .replace(/\\"/g, '"');
    }
    formatDate(value, datePattern = undefined) {
        if (value === null || value === undefined) {
            return "-";
        }
        if (datePattern !== undefined) {
            this._formatter._options.datePattern = datePattern;
        }
        return this._formatter.formatDate(value);
    }
    formatString(value) {
        if (value === null || value === undefined) {
            return "-";
        }
        return this._formatter.formatString(value.toString());
    }
    formatValue(value, attribute, useUnits = true) {
        if (value === null || value === undefined) {
            return "-";
        }
        this._formatter._options.useUnits = useUnits;
        const domain = attribute.getDomain();
        if (domain !== undefined) {
            return domain.resolveValue(value);
        }
        switch (attribute.getDataType()) {
            case AttributeDataType.Double:
            case AttributeDataType.Float:
                return this.formatFloat(value, attribute.getUnits(), attribute.getDecimals() === undefined
                    ? this._formatter._options.decimals
                    : attribute.getDecimals());
            case AttributeDataType.Integer:
                return this.formatInteger(value, attribute.getUnits());
            case AttributeDataType.Date:
                return this.formatDate(value);
            default: // string or anything else
                return this.formatString(value);
        }
    }
}
export const getValues = (feature) => {
    const values = {};
    feature.getProperties().forEach((property) => {
        values[property.getName()] = property.getValue();
    });
    return values;
};
export const getTemplateOptions = (layer, feature, icons) => {
    return {
        icons: icons,
        formatter: layer.getFormatter(),
        values: getValues(feature),
        geometry: feature.getGeometry(),
    };
};
//# sourceMappingURL=Formatter.js.map